query GetEvent($eventId: ID!) {
  event: StreamToolsGetEvent(eventId: $eventId) {
    eventId
    slug
    name
    description
    status
    createdAt
    startedAt
    endedAt
    youtubeSourceAttached
    youtubeForeignSources {
      channelId
      videoId
      attestedAt
      channelTitle
      channelProfileImageUrl
    }
    bots {
      eventId
      botUserId
      botLogin
      botDisplayName
      addedAt
    }
    channels {
      eventId
      broadcasterUserId
      channelLogin
      botUserId
      addedAt
      edge
      botAccess
    }
    polls {
      pollId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      youtubeVotesEnabled
      totalVotes
      closeGraceSeconds
      graceEndsAt
      youtubeCountsPurgedAt
      startedAt
      stoppedAt
      createdAt
      callToActionText
      headingTextColor
      optionsTextColor
      callToActionTextColor
      headingBackground
      optionsBackground
      callToActionBackground
      alternatingOptionBackground
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      winnerOutlineColor
      fontKey
      template
      tickerLabel
      ctaSubtext
      tickerTextSize
      tickerBlockWeights
      questionFontSize
      tickerLabelFontSize
      displayTextFontSize
      commandFontSize
      numberFontSize
      callToActionFontSize
      closedTextFontSize
      tickerHeight
      version
      options {
        optionId
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        textColor
        progressBarColor
        backgroundColor
      }
    }
    trivias {
      triviaId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      youtubeVotesEnabled
      totalVotes
      hasYouTubeVotes
      hideLiveResults
      showAnswersCounter
      closeGraceSeconds
      closedAt
      graceEndsAt
      revealedAt
      youtubeCountsPurgedAt
      answersIn { twitch youtube }
      startedAt
      stoppedAt
      createdAt
      callToActionText
      headingTextColor
      optionsTextColor
      callToActionTextColor
      headingBackground
      optionsBackground
      callToActionBackground
      alternatingOptionBackground
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      winnerOutlineColor
      fontKey
      questionFontSize
      displayTextFontSize
      commandFontSize
      numberFontSize
      callToActionFontSize
      revealTextFontSize
      version
      options {
        optionId
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        textColor
        progressBarColor
        isCorrect
        backgroundColor
      }
    }
    tugs {
      tugId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      youtubeVotesEnabled
      totalVotes
      startedAt
      stoppedAt
      graceEndsAt
      createdAt
      questionTextColor
      finalizedText
      finalizedTextColor
      backgroundColor
      chatCommandBackground
      barHeight
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      fontKey
      version
      optionA {
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        color
        textColor
        imageUrl
      }
      optionB {
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        color
        textColor
        imageUrl
      }
    }
    scoreboards {
      boardId
      eventId
      name
      createdAt
      title
      titleTextColor
      dividerColor
      backgroundColor
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      fontKey
      version
      competitors {
        competitorId
        boardId
        name
        score
        nameTextColor
        scoreTextColor
        imageUrl
        scoreImageUrl
      }
    }
    cameraControls {
      camControlId
      eventId
      name
      broadcasterUserIds
      commands {
        command
        count
      }
      changeLimit
      cooldownMs
      counterMode
      youtubeVotesEnabled
      status
      currentCommandIndex
      streak
      startedAt
      stoppedAt
      createdAt
      version
    }
    giveaways {
      giveawayId
      eventId
      name
      broadcasterUserIds
      entryCommand
      winnerCount
      alternateCount
      excludeBroadcaster
      excludeModerators
      rulesUrl
      sponsorName
      prizeName
      prizeImageUrl
      brandLogoUrl
      brandText
      backgroundImage
      backgroundImageFit
      titleText
      openCtaText
      entrantsLabel
      openFooterText
      upcomingHeadline
      upcomingCtaText
      closedHeadline
      closedSubhead
      closedBody
      closedFooterText
      endedHeadline
      congratsText
      endedFooterText
      rulesLabel
      legalText
      fontKey
      textColor
      background
      borderColor
      borderWidth
      cornerRadius
      winnerOutlineColor
      accentBackground
      accentTextColor
      titleFontKey
      textFontKey
      captionFontKey
      subtitleFontKey
      prizeImageRadius
      prizeImageBorderWidth
      prizeImageBorderColor
      prizeImageWidthPx
      countDividerEnabled
      countDividerColor
      countDividerWidthPx
      brandDividerEnabled
      brandDividerColor
      brandDividerWidthPx
      status
      entrantCount
      startedAt
      closedAt
      publishedAt
      createdAt
      version
      hasDraw
      winners {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      draw {
        drawId
        methodVersion
        eligibleCount
        targetRound
        fallbackUsed
        drawnAt
        shortPool
        requestedWinnerCount
        requestedAlternateCount
        winners {
          twitchUserId
          login
          displayName
          rank
          kind
          disqualifiedAt
          disqualifiedReason
        }
        alternates {
          twitchUserId
          login
          displayName
          rank
          kind
          disqualifiedAt
          disqualifiedReason
        }
        disqualifications {
          twitchUserId
          reason
          byUserId
          at
          promotedTwitchUserId
        }
      }
    }
    members {
      eventId
      userId
      email
      displayName
      role
      addedBy
      addedAt
    }
  }
}
